import AuthManager from "../../common/auth/Manager";

const isAuthorized = (to, from, next) => {
    if (AuthManager.isGuest()) {
        next({name: 'login'})
    } else {
        AuthManager.isClient() ?  next({name: 'available-protocols'}) :  next({name: 'client'})
    }
};

export default isAuthorized;


// WEBPACK FOOTER //
// ./src/router/hooks/defaultIsGuest.js